import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { applicationList, deleteApplication } from './request';
import standardTable from '@/components/standardTable/index';
import { customerResource } from './../../system/customerManage/request';
import applicationModel from './applicationModel';
import seeApplicationModel from './seeApplicationModel.vue';
const tableHead = [{
  slots: {
    title: '序号'
  },
  dataIndex: 'index',
  scopedSlots: {
    customRender: 'index'
  },
  width: 80,
  align: 'center'
}, {
  slots: {
    title: '应用名称'
  },
  dataIndex: 'name',
  align: 'center'
}, {
  slots: {
    title: '应用类型'
  },
  dataIndex: 'type',
  align: 'center',
  scopedSlots: {
    customRender: 'type'
  }
}, {
  slots: {
    title: 'appId'
  },
  dataIndex: 'appid',
  align: 'center'
}, {
  slots: {
    title: '更新时间'
  },
  dataIndex: 'updateAt',
  align: 'center'
}, {
  slots: {
    title: '操作'
  },
  scopedSlots: {
    customRender: 'action'
  },
  align: 'center',
  width: 230
}];
// {title: '所属客户',dataIndex: 'customerName',align: 'center'},
export default {
  components: {
    standardTable,
    applicationModel,
    seeApplicationModel
  },
  data() {
    return {
      loading: false,
      form: {
        customerId: undefined,
        name: '',
        type: undefined
      },
      customerList: [],
      currentRow: null,
      dialogVisible: false,
      dialogVisible2: false,
      tableData: [],
      tableHead,
      seeShow: false,
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      }
    };
  },
  created() {
    customerResource({
      isLicense: 1
    }).then(res => {
      this.customerList = res;
      let arr = this.customerList.filter(item => item.id == Number(sessionStorage.getItem('customerId')));
      console.log(arr, 55);
      this.form.customerId = arr.length != 0 ? Number(sessionStorage.getItem('customerId')) : res[0].id;
      this.customerIdFun();
      this.getApplicationTable();
    });
  },
  methods: {
    filterOption(input, option) {
      return option.componentOptions.children[0].componentOptions.propsData.title.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    customerIdFun() {
      sessionStorage.setItem('customerId', Number(this.form.customerId) || '');
    },
    getApplicationTable() {
      let obj = this.form;
      Object.assign(obj, {
        page: this.pagination.current,
        pageSize: this.pagination.pageSize
      });
      applicationList(obj).then(res => {
        console.log(res);
        this.tableData = res.items || [];
        this.pagination.total = res.totalNum;
      });
    },
    handleAdd() {
      this.currentRow = {};
      this.dialogVisible = true;
    },
    handleEdit(val, type) {
      this.currentRow = val;
      this.dialogVisible = true;
    },
    handleSee(val) {
      this.currentRow = val;
      this.dialogVisible2 = true;
    },
    handleStandardTableChange(val) {
      console.log(val);
      this.pagination = val;
      this.getApplicationTable();
    },
    getSeachFun() {
      this.pagination.current = 1;
      this.getApplicationTable();
    },
    handleOk() {
      this.dialogVisible = false;
      this.currentRow = null;
      this.pagination.current = 1;
      this.getApplicationTable();
    },
    handleDelete(val) {
      let _this = this;
      this.$alert(_this.$t('是否确认删除该应用') + '?', {
        confirmButtonText: _this.$t('确定')
      }).then(() => {
        deleteApplication({
          applicationId: val.applicationId
        }).then(() => {
          _this.$message.success(_this.$t('删除成功') + '!');
          _this.getApplicationTable();
        });
      });
    }
  }
};